var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center", attrs: { "no-gutters": "" } },
    [
      _c(
        "b-col",
        {
          attrs: {
            id: "request-list-classification-select-container",
            cols: "12",
          },
        },
        [
          _c("document-classification-select", {
            attrs: {
              id: "request-list-classification-select",
              "select-dropdown-parent":
                "#request-list-classification-select-container",
              classifications: _vm.DOCUMENT_TYPES_SELECT,
              loading: _vm.loading,
              "allow-create": true,
              disabled: _vm.loading,
            },
            on: { change: _vm.handleClassificationSelection },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }